export default "__VITE_ASSET__DCVKfZJI__"